import { useQuery } from '@apollo/client';
import { useMemo, useState } from 'react';

export function useCacheQueryData(query: any, variable: any, condition: any, isNetWorkOnly?: any, onCompleted?: any) {
    const [dataQuery, setDataQuery] = useState<any>();
    const onGetDataQuery = useMemo(
        () => (response) => {
            setDataQuery(response);
        },
        [setDataQuery],
    );
    let { loading } = useQuery(query, {
        fetchPolicy: typeof isNetWorkOnly === 'string' ? isNetWorkOnly : isNetWorkOnly && 'network-only',
        variables: {
            input: variable,
        },
        onCompleted(response) {
            onGetDataQuery(response);
            if (onCompleted) {
                onCompleted();
            }
        },
        onError(error) {
            console.log('get data Failed: ', error);
        },
    });

    return { dataQuery, loading };
}
